export default "__VITE_ASSET__CpmLNI_O__"